(function () {
  'use strict';

  angular
      .module('tfc.sso')
      .controller('LoginCtrl', LoginCtrl);

  // @ngInject
  function LoginCtrl(Auth) {
    var vm = this;
    vm.usingActiveDirectory = Auth.usingActiveDirectory;

    vm.user = {};

    vm.login = function () {
      Auth.login(vm.user);
    };
  }

})();
